var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenInNewArrow = function SvgOpenInNewArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.559a.8.8 0 0 1 .8-.8h2.4a.8.8 0 1 1 0 1.6H1.6v7.2h7.202v-1.6a.8.8 0 0 1 1.6 0v2.4a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.598.959a.8.8 0 0 1 .8-.8H11.2a.8.8 0 0 1 .8.8v4.8a.8.8 0 0 1-1.6 0V2.893L6.167 7.124a.8.8 0 0 1-1.131-1.131L9.27 1.759H6.399a.8.8 0 0 1-.8-.8"
  })));
};
export default SvgOpenInNewArrow;